import * as React from "react";
import "./style.scss";
import {TextField, SelectField} from "web-com";
import {INPUT_TYPE, StyleType} from "utils/variables";
import {FIELD_NAMES} from "profile/enums";
import {IResidenceAddressFields} from "IncompleteInfoV2/ResidenceAddress/index";
import {maxPincodeLength} from "IncompleteInfoV2/utils";

interface IProps {
    fields: IResidenceAddressFields;
    onChange: (fieldName: string, value: string) => void;
    errors: {[key: string]: string};
}

interface IOptions {
    name: string;
    value: string;
}

const selectFieldOptions: IOptions[] = [
    {name : "Select", value: ""},
    {name : "Rented", value : "Rented"},
    {name : "OwnHouse", value : "OwnHouse"},
];

export const AddressFields = (props: IProps) => {
    const {residentType, resTenure, house, street, locality, landmark, pincode} = props.fields;
    const handleChange = (fieldName: string, value: string) => {
        props.onChange(fieldName, value);
    };

    return <div className="address-fields-container">
        <SelectField
            fieldName={FIELD_NAMES.RESIDENT_TYPE}
            value={residentType}
            name="Resident Type"
            options={selectFieldOptions}
            onChangeHandler={handleChange}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            errorMsg={props.errors[FIELD_NAMES.RESIDENT_TYPE] || null}/>
        <TextField
            type={INPUT_TYPE.DATE}
            label="Staying Since"
            value={resTenure}
            fieldName={FIELD_NAMES.RES_TENURE}
            errorMsg={props.errors[FIELD_NAMES.RES_TENURE] || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            onChange={handleChange}/>
        <TextField
            type={INPUT_TYPE.TEXT}
            label="House No"
            placeholder="Please enter house no"
            value={house}
            fieldName={FIELD_NAMES.HOUSE}
            errorMsg={props.errors[FIELD_NAMES.HOUSE] || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            onChange={handleChange}/>
        <TextField
            type={INPUT_TYPE.TEXT}
            label="Street Name"
            placeholder="Please enter street name"
            value={street}
            fieldName={FIELD_NAMES.STREET}
            errorMsg={props.errors[FIELD_NAMES.STREET] || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            onChange={handleChange}/>
        <TextField
            type={INPUT_TYPE.TEXT}
            label="Locality"
            placeholder="Please enter locality"
            value={locality}
            fieldName={FIELD_NAMES.LOCALITY}
            errorMsg={props.errors[FIELD_NAMES.LOCALITY] || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            onChange={handleChange}/>
        <TextField
            type={INPUT_TYPE.TEXT}
            label="Landmark"
            placeholder="Please enter landmark"
            value={landmark}
            fieldName={FIELD_NAMES.LANDMARK}
            errorMsg={props.errors[FIELD_NAMES.LANDMARK] || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            onChange={handleChange}/>
        <TextField
            type={INPUT_TYPE.NUMBER}
            label="Pincode"
            placeholder="Please enter pincode"
            value={pincode}
            fieldName={FIELD_NAMES.PINCODE}
            errorMsg={props.errors[FIELD_NAMES.PINCODE] || null}
            onChange={handleChange}
            styleType={StyleType.BORDER_BOTTOM_INPUT}
            max={maxPincodeLength}/>
    </div>;
};

export default AddressFields;
